import { SearchableItem } from './data'
import { SearchItem } from './types'

/**
 * Converts a SearchableItem to a SearchItem for use in the MavFinder component
 *
 * @param item The searchable item to convert
 * @returns A SearchItem for use in MavFinder
 */
const convertToSearchItem = (item: SearchableItem): SearchItem => {
	return {
		id: item.id,
		label: item.label,
		to: item.to,
		icon: item.icon,
		type: item.type as any, // Note: We're converting SearchItemType to SearchResultType
		section: getSection(item.to || '', item.type),
		keywords: item.keywords
	}
}

/**
 * Gets the section name based on the URL path
 *
 * @param path The URL path
 * @param type The type of the item
 * @returns The section name
 */
const getSection = (path: string, type: string): string => {
	if (path.includes('/decoder')) return 'Decoder'
	if (path.includes('/herd')) return 'Herd'
	if (path === '/news') return 'News'
	if (path === '/nexus') return 'Nexus'
	if (path === '/watchlist') return 'Watchlist'
	if (path === '/state-of-market') return 'Market'
	if (path === '/mavbots-arena') return 'MavBots'

	// For company items
	if (path.includes('/decoder/navigator/') && type === 'Company') {
		return 'Companies'
	}

	return ''
}

/**
 * Builds a search index from the searchable items
 *
 * @param items The list of searchable items
 * @returns A list of search items
 */
export const buildSearchIndex = (items: SearchableItem[]): SearchItem[] => {
	return items.map(item => convertToSearchItem(item))
}
